import React from 'react';
import PropTypes from 'prop-types';
import {Modal, Button, Checkbox} from 'react-bootstrap';
import styled from 'styled-components';
import {
  showCopyToQodModal, getAvailableWoMemfises, createPendingRequestProxy, doShareQodProxy, copyFsItem,
  saveMarkedWOAndAddFileToWO, closeModalAddFileToWO, getReferenceAssetList, createGeneralProxyCopyAction
} from '../../actions';
import TextEllipsisAdvanced from '../../../../components/TextEllipsis/TextEllipsisAdvanced';
import {showError} from '../../../../layouts/actions';
import ReportBugButton from '../../../../components/ReportBugButton';
import {getValueForOS, getCopyToQodInfoList} from '../../utils';
import RndModal from '../../../../components/modals/RndModal';
import {confirmAlert} from 'react-confirm-alert';
import store from "../../../../store";

const Steps = {
  CHOOSE_PROXY_MODE_STEP: 'Choose proxy mode: new proxy or share',
  SHARE_PROXY_STEP: 'Share proxy',
  NEW_PROXY_STEP: 'New proxy',
  CHOOSE_ARTWORK_PROXY_TYPE_STEP: 'Choose artwork proxy type: mux or not',
  ARTWORK_MUX_PROXY_STEP: 'Artwork mux proxy'
};

class CopyToQodModal extends React.PureComponent {
  state = {
    currentStep: Steps.CHOOSE_PROXY_MODE_STEP,
    isDirectUploadProxy: false,
    isMpegDashProxy: false,
    isContinueCopy: false,
    isShareProxy: false,
    checkedWorkOrders: [],
    isArtworkWorkOrder: false,
    artworkChooseStep: true,
    checkedArtworkRequests: [],
    mixProxyMode: false,
    referenceArtworkAssets: [],
  }

  handleClose = () => {
    const {mixProxyMode} = this.state;
    if (mixProxyMode) {
      this.setState({
        mixProxyMode: false
      });
      return;
    }

    const {dispatch} = this.props;
    dispatch(showCopyToQodModal(false));
  };

  componentWillUnmount() {
    this.handleClose();
  }

  isStepForAddFileToWO = () => {
    const {addFileToWoModalState: {proxyCopyAvailable, isCreateQODProxyChecked}} = this.props;
    return proxyCopyAvailable && isCreateQODProxyChecked;
  };

  getChoosedWoMemfis = () => {
    if (this.isStepForAddFileToWO()) {
      const {addFileToWoModalState: {currentWOMemfis}} = this.props;
      return currentWOMemfis;
    }
    return null;
  };

  getCopyToQodInfoWoMemfisList = () => {
    const {copyToQodModalState, item} = this.props;
    const copyToQodInfoList = getCopyToQodInfoList(copyToQodModalState, [item]);
    return copyToQodInfoList.map(item => item.woMemfis).filter(Boolean);
  };

  componentDidMount() {
    const {dispatch, copyToQodModalState: {ownProxyName}} = this.props;

    const choosedWoMemfis = this.getChoosedWoMemfis();

    dispatch(getAvailableWoMemfises(choosedWoMemfis)).then((res) => {
      const availableWOmemfises = res.work_order_list;
      // when we from "Add Link to WO" -> do not use "Share Proxy" feature
      if (this.isStepForAddFileToWO()) {
        this.setState({
          currentStep: Steps.NEW_PROXY_STEP,
          isContinueCopy: true
        });
      }

      const createProxyForArtworkAsset = availableWOmemfises && availableWOmemfises.length > 0 && availableWOmemfises[0].WOType === 'ARTWORK';
      const {email} = store.getState().user;
      const enableFeatureCopyWithWoMemfis = email && true; //(email.includes('berkman') || email.includes('morozov'));
      if (createProxyForArtworkAsset && enableFeatureCopyWithWoMemfis) {
        this.setState({
          currentStep: Steps.CHOOSE_ARTWORK_PROXY_TYPE_STEP,
          isArtworkWorkOrder: availableWOmemfises[0].WOType === 'ARTWORK'
        });
        return;
      }

      // if work order (for selected file) has uploaded proxy
      if (ownProxyName) {
        this.setState({
          currentStep: Steps.CHOOSE_PROXY_MODE_STEP
        });
        return;
      }

      const currentWoMemfisArr = choosedWoMemfis ? [choosedWoMemfis] : this.getCopyToQodInfoWoMemfisList();

      // only for copy process
      const currentWorkOrders = availableWOmemfises && availableWOmemfises.length > 0 ? availableWOmemfises.filter(item => item.WOType !== 'ARTWORK' && currentWoMemfisArr.includes(item.WOMemfis)) : null;
      if (currentWorkOrders) {
        this.setState({checkedWorkOrders: currentWorkOrders.map(item => item.WOID)});
      }
    }).catch(e => showError(e));
  }

  handleOnChange = (woid) => {
    const {checkedWorkOrders} = this.state;
    const index = checkedWorkOrders.indexOf(woid);

    const newValue = [...checkedWorkOrders];
    if (index !== -1) {
      newValue.splice(index, 1);
    } else {
      newValue.push(woid);
    }
    this.setState({checkedWorkOrders: newValue});
  };

  handleOnChangeArtwork = (artworkRequestID) => {
    const { checkedArtworkRequests } = this.state;
    const index = checkedArtworkRequests.indexOf(artworkRequestID);

    const newValue = [...checkedArtworkRequests];
    if (index !== -1) {
      newValue.splice(index, 1);
    } else {
      newValue.push(artworkRequestID);
    }
    this.setState({checkedArtworkRequests: newValue});
  }

  handleOnShareProxy = () => {
    const {dispatch} = this.props;
    const {checkedWorkOrders} = this.state;

    dispatch(doShareQodProxy(checkedWorkOrders));
  };

  handleOnCreateProxy = () => {
    const {dispatch, copyModalData, item} = this.props;
    const {checkedWorkOrders, checkedArtworkRequests, isDirectUploadProxy, isMpegDashProxy} = this.state;
    const {destFsRootID, destination, newFileName} = copyModalData;

    dispatch(createPendingRequestProxy(checkedWorkOrders, checkedArtworkRequests, isDirectUploadProxy, isMpegDashProxy))
      .then((res) => {
        if (res && res.request_proxy_id > 0) {
          // the copied file will be uploaded to AWS S3, with "pid" parameter it will have a unique name
          const filenameForProxy = 'pid' + res.request_proxy_id + '_' + (newFileName || item.name).replace(/[.]mov$/, res.proxy_mux_required && (newFileName || item.name).indexOf("_muxed")<0 ? "_muxed.mov" : ".mov");
          dispatch(copyFsItem(true, destFsRootID, destination, filenameForProxy, true));
        } else {
          dispatch(showError('Failed create QOD proxy, we cannot start copying file'));
        }
      })
      .catch((error) => {
        dispatch(showError('Failed create QOD proxy: ' + error));
      });
  };

  handleOnSubmit = () => {
    const {dispatch} = this.props;
    const {checkedWorkOrders, isDirectUploadProxy, isMpegDashProxy} = this.state;

    dispatch(saveMarkedWOAndAddFileToWO(checkedWorkOrders, isDirectUploadProxy, isMpegDashProxy));
  };

  handleCancelAddFileToWO = () => {
    const {dispatch} = this.props;
    confirmAlert({
      childrenElement: () =>
        <h5 className="custom-msg">
          Are you sure you want to cancel "Add to WO"?
        </h5>,
      buttons: [{
        label: 'No'
      }, {
        label: 'Yes',
        onClick: () => {
          this.handleClose();
          dispatch(closeModalAddFileToWO());
        }
      }]
    });
  };

  handleOnCreateMuxArtworkProxy = () => {
    const {dispatch, copyModalData} = this.props;
    const {referenceArtworkAssets, checkedArtworkRequests, isDirectUploadProxy, isMpegDashProxy} = this.state;
    const {destFsRootID, destination} = copyModalData;

    checkedArtworkRequests.forEach(artworkRequestId => {
      const referenceAsset = referenceArtworkAssets.find(a => a.RequestID === artworkRequestId);
      if (!referenceAsset) {
        return;
      }

      dispatch(createPendingRequestProxy([], [artworkRequestId], isDirectUploadProxy, isMpegDashProxy))
          .then((res) => {
            if (res && res.request_proxy_id > 0) {
              // the copied file will be uploaded to AWS S3, with "pid" parameter it will have a unique name
              const assetNameWithoutExtension = referenceAsset.AssetName.split('.').slice(0, -1).join('.');
              const filenameForProxy = 'pid' + res.request_proxy_id + '_' + assetNameWithoutExtension + ".mp4";
              dispatch(createGeneralProxyCopyAction(referenceAsset.DAT_FsRootID, referenceAsset.DAT_ContentID, referenceAsset.WOMemfis, destFsRootID, destination, filenameForProxy));
            } else {
              dispatch(showError('Failed create QOD proxy, we cannot start copying file'));
            }
          })
          .catch((error) => {
            dispatch(showError('Failed create QOD proxy: ' + error));
          });
    });
  };

  handleOnSelectMuxArtworkProxy = () => {
    const {dispatch, copyToQodModalState, item} = this.props;
    const {availableWOmemfises, woClientName} = copyToQodModalState;

    let workOrderItemForSelectedFile;
    if (woClientName) {
      workOrderItemForSelectedFile = availableWOmemfises.find(w => w.AssetName === item.name && w.ClientName === woClientName);
    } else {
      workOrderItemForSelectedFile = availableWOmemfises.find(w => w.AssetName === item.name);
    }
    if (!workOrderItemForSelectedFile) {
      dispatch(showError("Can not find artwork asset for selected file"));
      return;
    }

    this.setState({currentStep: Steps.ARTWORK_MUX_PROXY_STEP, isShareProxy: true});

    const qodRequestId = workOrderItemForSelectedFile.RequestID;
    dispatch(getReferenceAssetList(qodRequestId)).then((response) => {
      this.setState({
        referenceArtworkAssets: response.reference_asset_list || []
      });
    }).catch(e => showError(e));
  };

  renderUploadProxyOptions = () => {
    return (
        <div>
          <Checkbox
              checked={this.state.isDirectUploadProxy}
              onChange={({target: {checked}}) => this.setState({isDirectUploadProxy: checked, isMpegDashProxy: false})}
          >
            Direct Proxy
          </Checkbox>
          <Checkbox
              checked={this.state.isMpegDashProxy}
              onChange={({target: {checked}}) => this.setState({isMpegDashProxy: checked, isDirectUploadProxy: false})}
          >
            MPEG-DASH Proxy
          </Checkbox>
        </div>
    )
  }

  renderModalContent = () => {
    const {copyToQodModalState, loaders} = this.props;
    const {availableWOmemfises, ownProxyName} = copyToQodModalState;
    const { currentStep, referenceArtworkAssets, checkedWorkOrders, checkedArtworkRequests } = this.state;

    if (loaders.getAvailableWoMemfises) {
      return (
          <span>Loading...</span>
      );
    }

    if (!availableWOmemfises.length) {
      return (
          <div>There are no available work orders for selected file</div>
      );
    }

    let woMemfisArr = this.getCopyToQodInfoWoMemfisList();
    if (woMemfisArr.length > 1 && availableWOmemfises) {
      woMemfisArr = woMemfisArr.filter(woMemfis => availableWOmemfises.some(item => item.WOMemfis === woMemfis));
    }

    const choosedWoMemfis = this.getChoosedWoMemfis();
    const currentWoMemfisArr = choosedWoMemfis ? [choosedWoMemfis] : woMemfisArr;
    const woInfoElement = (
        <div>
          {currentWoMemfisArr.length ? 'Found WO#: ' + currentWoMemfisArr.join(', ') : 'Work Order not found'}
        </div>
    );

    if (currentStep === Steps.CHOOSE_ARTWORK_PROXY_TYPE_STEP) {
      return (
          <>
            {woInfoElement}
            <div>The selected file is an artwork asset</div>
            <div>What do you want to do?</div>
            <Button
                bsStyle="primary"
                onClick={() => this.setState({currentStep: Steps.NEW_PROXY_STEP, isContinueCopy: true})}
            >
              Continue creating proxy using only the selected file
            </Button>
            <span> </span>
            <Button
                bsStyle="primary"
                onClick={() => this.handleOnSelectMuxArtworkProxy()}
            >
              Select audio file(s) to create MUX proxy/proxies
            </Button>
          </>
      );
    }

    if (currentStep === Steps.ARTWORK_MUX_PROXY_STEP) {
      return (
          <>
            {woInfoElement}
            <div>Select artwork assets for which we will create a MUX proxy:</div>
            <table className="memfises-table">
              <tbody>
              <tr>
                <th className="wo-table-assetname-cell">Asset</th>
                <th className="wo-table-filepath-cell">File Path</th>
                <th className="checkbox-head-cell"></th>
              </tr>
              {referenceArtworkAssets.map(item => (
                  <tr key={item.RequestID}>
                    <td className="wo-table-assetname-cell">{item.AssetName}</td>
                    <td className="wo-table-filepath-cell">{item.FilePath}</td>
                    <td className="checkbox-table-cell">
                      <input
                          type="checkbox"
                          checked={ checkedArtworkRequests.includes(item.RequestID) }
                          value={ item.RequestID }
                          onChange={ () => this.handleOnChangeArtwork(item.RequestID) }
                      />
                    </td>
                  </tr>
              ))}
              </tbody>
            </table>
            {this.renderUploadProxyOptions()}
          </>
      );
    }

    if (currentStep === Steps.CHOOSE_PROXY_MODE_STEP) {
      return (
          <>
            {woInfoElement}
            <div>This work order already has proxy: {ownProxyName}</div>
            <div>What do you want to do?</div>
            <Button
                bsStyle="primary"
                onClick={() => this.setState({currentStep: Steps.SHARE_PROXY_STEP, isShareProxy: true})}
            >
              Share this proxy with other work orders
            </Button>
            <span> </span>
            <Button
                bsStyle="primary"
                onClick={() => this.setState({currentStep: Steps.NEW_PROXY_STEP, isContinueCopy: true})}
            >
              Continue create proxy process
            </Button>
          </>
      );
    }

    if (currentStep === Steps.SHARE_PROXY_STEP) {
      return (
          <>
            {woInfoElement}
            <div>This is work orders without proxy, select for share proxy:</div>
            <table className="memfises-table">
              <tbody>
              <tr>
                <th className="wo-table-cell">WO#</th>
                <th className="checkbox-head-cell"></th>
              </tr>
              {availableWOmemfises.filter(item => !woMemfisArr.includes(item.WOMemfis) && !item.ProxyName && !item.ProxyCreatedOn).map(item => (
                  <tr key={item.WOID}>
                    <td className="wo-table-cell">{item.WOMemfis}{item.Format ? ` - ${item.Format.replaceAll('/', ' ')}` : ''}</td>
                    <td className="checkbox-table-cell">
                      <input
                          type="checkbox"
                          checked={ checkedWorkOrders.includes(item.WOID) }
                          value={ item.WOID }
                          onChange={ () => this.handleOnChange(item.WOID) }
                      />
                    </td>
                  </tr>
              ))}
              </tbody>
            </table>
          </>
      );
    }

    // when current step is NEW_PROXY_STEP
    return (
        <>
          {woInfoElement}
          <div>Select work orders for which we will upload a new proxy:</div>
          <table className="memfises-table">
            <tbody>
            <tr>
              <th className="wo-table-cell">WO#</th>
              <th className="wo-table-cell">Title</th>
              <th className="has-proxy-cell">Proxy State</th>
              <th className="proxy-date-cell">Date</th>
              <th className="checkbox-head-cell"></th>
            </tr>
            {availableWOmemfises.map(item => (
                <tr key={item.RequestID}>
                  <td className="wo-table-cell">{item.WOMemfis}{item.Format ? ` - ${item.Format.replaceAll('/', ' ')}` : ''}</td>
                  <td className="wo-table-cell">{item.Title}{item.WOType === 'ARTWORK' ? ` - ${item.AssetName}` : ''}</td>
                  <td className="has-proxy-cell" title={ item.ProxyName }>{ item.ProxyName ? 'Created' : item.ProxyCreatedOn ? 'Pending' : 'No' }{ item.ProxyName && checkedWorkOrders.includes(item.WOID) ? <span> (the existing proxy will be overwritten)</span> : ''}</td>
                  <td>{ item.ProxyCreatedOn || '-'}</td>
                  <td className="checkbox-table-cell">
                    {
                      item.WOType === 'ARTWORK' ? <input
                          type="checkbox"
                          checked={ checkedArtworkRequests.includes(item.RequestID) }
                          value={ item.RequestID }
                          onChange={ () => this.handleOnChangeArtwork(item.RequestID) }
                      /> : <input
                          type="checkbox"
                          checked={ checkedWorkOrders.includes(item.WOID) }
                          value={ item.WOID }
                          onChange={ () => this.handleOnChange(item.WOID) }
                          disabled={ currentWoMemfisArr.includes(item.WOMemfis) }
                      />
                    }
                  </td>
                </tr>
            ))}
            </tbody>
          </table>
          {this.renderUploadProxyOptions()}
        </>
    );
  }

  render() {
    const {item} = this.props;
    const { currentStep, mixProxyMode } = this.state;

    const isStepForAddFileToWO = this.isStepForAddFileToWO();

    const ActionButton = () => {
      // if work order has proxy -> user needs to make a choice - share or re-write proxy
      if (currentStep === Steps.CHOOSE_PROXY_MODE_STEP || currentStep === Steps.CHOOSE_ARTWORK_PROXY_TYPE_STEP) {
        return null;
      }

      if (isStepForAddFileToWO) {
        return (
          <Button
            bsStyle="primary"
            onClick={this.handleOnSubmit}
          >
            Submit
          </Button>
        );
      }

      if (currentStep === Steps.SHARE_PROXY_STEP) {
        return (
          <Button
            bsStyle="primary"
            onClick={this.handleOnShareProxy}
          >
            Share Proxy
          </Button>
        );
      }

      if (currentStep === Steps.ARTWORK_MUX_PROXY_STEP) {
        return (
            <Button
                bsStyle="primary"
                title="For Dub Mov or AudioStems Zip artwork assets"
                onClick={this.handleOnCreateMuxArtworkProxy}
            >
              Create MUX Proxy
            </Button>
        );
      }

      return (
          <Button
              bsStyle="primary"
              onClick={this.handleOnCreateProxy}
          >
            Start Create Proxy
          </Button>
      );
    };

    return (
      <RndModal
        bsSize="large"
        className="move-modal"
        show={true}
        onHide={this.handleClose}
        backdrop="static"
        enforceFocus={false}
      >
        <Modal.Header closeButton={!isStepForAddFileToWO}>
          <Modal.Title>
            {isStepForAddFileToWO ? 'Add to WO: ' : ''}Create QOD Proxy
            <ReportBugButton isForModal={true} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContainerStyled className="container-fluid">
            <div className="source-div">
              <span className="source-label">Source: </span>
              <TextEllipsisAdvanced className="source-value" data={getValueForOS(item, 'key')}/>
            </div>
            {this.renderModalContent()}
          </ModalContainerStyled>
        </Modal.Body>
        <Modal.Footer>
          {isStepForAddFileToWO || mixProxyMode ?
            <Button bsStyle="default" onClick={this.handleClose}>
              Back
            </Button> : null
          }
          <ActionButton />
          <Button bsStyle="default" onClick={isStepForAddFileToWO ? this.handleCancelAddFileToWO : this.handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </RndModal>
    );
  }
}

const ModalContainerStyled = styled.div`
  min-height: 200px;

  .source-div {
    display: flex;
  }
  > div {
    margin-bottom: 5px;
  }
  .source-label {
    flex: 0 0 65px;
  }
  .source-value {
    color: blue;
    word-break: break-word;
    max-width: calc(100% - 65px);
  }
  .memfises-table {
    border-collapse: collapse;
    width: 100%;
    display: table;
    margin-top: 5px;
    
    tr {
      td, th {
        border: 2px solid grey;
        padding: 4px 0 4px 4px;
        
        &.wo-table-cell, &.wo-table-filepath-cell, &.wo-table-filepath-cell {
          padding: 4px 0 4px 10px;
        }

        &.wo-table-filepath-cell, &.wo-table-filepath-cell {
          word-break: break-all;
        }

        &.checkbox-head-cell {
          width: 40px;
        }

        &.checkbox-table-cell {
          text-align: center;
        }

        &.has-proxy-cell span {
          color: #f57c00;
        }
      }
    }
  }
  .loader-container {
    z-index: 1051;
  }
  .warning-renamed {
    display: flex;
    align-items: center;
    padding-bottom: 20px;

    i {
      font-size: 22px;
      color: red;
      margin-right: 5px;
    }
  }
`;

CopyToQodModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  copyModalData: PropTypes.object.isRequired,
  copyToQodModalState: PropTypes.object,
  addFileToWoModalState: PropTypes.object,
  loaders: PropTypes.object,
};

export default CopyToQodModal;
